import { fetchStorageDashboardSummary as fetchPlatformStorageDashboardSummary } from '@jarvis/platform-ui/storage-dashboard';
import { apiFetch } from './client';

/** WebOps dashboard cards open SPR — use the SPR mount catalog. */
export const fetchStorageDashboardSummary = () =>
  fetchPlatformStorageDashboardSummary(apiFetch, { catalog: 'spr' });
